import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { InputStyled, LabelInput, Required } from '../../../components/globals/FormController';
import GlobalTheme from '../../../styled/GlobalTheme';

const PromoCodeContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

const LabelInvalid = styled(Required)`
  margin-top: 10px;
`;

const LabelValid = styled(LabelInvalid)`
  color: ${(props) => props.theme.colors.lightBlue};
`;

const CustomLabelInput = styled(LabelInput)`
  && {
    font-size: 14px;
    margin: 0 8px 0 0;
  }
`;

const Input = styled(InputStyled)`
  width: auto;
  margin-left: 8px;
  ${GlobalTheme.breakpoints.down('sm')} {
    margin: 8px 0 0;
    width: 100%;
  }
`;

export default function factoryPromoCode(PromoCode, handlePromoCodeChange) {
  return (
    <PromoCodeContainer>
      <CustomLabelInput>
        <FormattedMessage
          id="onboarding.creteAccount.doyouhavecode"
          defaultMessage="Do you have a promotional code?"
        />
      </CustomLabelInput>
      <Input
        onChange={handlePromoCodeChange}
        value={PromoCode.code}
        placeholder="ABCD1234"
        id="promocode"
        type="text"
      />
      {(!PromoCode.isValid && PromoCode.code) && (
      <LabelInvalid>
        <FormattedMessage
          id="onboarding.creteAccount.invalidcode"
          defaultMessage="Invalid Code"
        />
      </LabelInvalid>
      )}
      {PromoCode.isValid && (
      <LabelValid>
        <FormattedMessage
          id="onboarding.creteAccount.validcode"
          defaultMessage="Valid Code"
        />
      </LabelValid>
      )}
    </PromoCodeContainer>
  );
}
